import Cookies from 'js-cookie';

export const getApiKeyFromCookie = (): string | null => {
    const API_KEY = Cookies.get('API_KEY') || null;
    return API_KEY;
};
